module.exports = __webpack_public_path__ + "static/media/calendar-with-header.2f52c639.png";